exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pre-wrap[data-v-607cea9f]{white-space:pre-wrap}", ""]);

// exports
